import NavigatorView from "../../navigation/NavigatorView";
import RouteSwitch from "../../navigation/RouteSwitch";
import RouteView from "../../navigation/RouteView";
import { userRoute, usersNavigator, usersRoute } from "./navigation";
import UserPage from "./UserPage";
import UsersPage from "./UsersPage";

export default function UsersNavigator() {
    return (
        <NavigatorView navigator={usersNavigator}>
            <RouteSwitch>
                <RouteView route={usersRoute} component={UsersPage} />
                <RouteView route={userRoute} component={UserPage} />
            </RouteSwitch>
        </NavigatorView>
    );
}
